export class LineFormula {
  slope: number;
  yIntercept: number;
  xAsymptote?: number;

  constructor(
    slope: number,
    yIntercept: number,
    xAsymptote: number = undefined
  ) {
    this.slope = slope;
    this.yIntercept = yIntercept;
    this.xAsymptote = xAsymptote;
  }

  public calculateY(x: number): number {
    return this.slope * x + this.yIntercept;
  }

  public calculateX(y: number): number {
    return (y - this.yIntercept) / this.slope;
  }

  public isVerticalAsymptote(): boolean {
    return this.slope === Infinity || this.slope === -Infinity;
  }
}
